export const DELETEDLIST_PAGE = 'DELETEDLIST_PAGE';
export const DELETEDLIST_SEARCH = 'DELETEDLIST_SEARCH';